export default __webpack_public_path__ + "static/media/energy.09538bcd.jpeg";